import { DayOfWeekEnum } from "./DayOfWeekEnum";
import { ReportSubscriptionChannelEnum } from "./ReportSubscriptionChannelEnum";
import { ReportSubscriptionTypeEnum } from "./ReportSubscriptionTypeEnum";

export class ReportSubscription {
    public clientUserName: string = "";
    public reportSubscriptionType: ReportSubscriptionTypeEnum;
    public options: ReportSubscriptionOptions;
    public time: string = "23:00";
    public days: DayOfWeekEnum = DayOfWeekEnum.Monday | DayOfWeekEnum.Wednesday | DayOfWeekEnum.Friday;
    public channel: ReportSubscriptionChannelEnum;
    public params: string;

    parse(obj: any) {
        this.clientUserName = obj.ClientUserName;
        this.reportSubscriptionType = obj.ReportSubscriptionType;
        if (obj.Options != null) {
            this.options = new ReportSubscriptionOptions();
            this.options.parse(obj.Options);
        }
        this.time = obj.Time;
        this.days = obj.Days;
        this.channel = obj.Channel;
        this.params = obj.Params;
    }
}

export class ReportSubscriptionOptions {
    public startTime: string = null;
    public endTime: string = null;
    public format: string[];

    parse(obj: any) {
        if (obj != null) {
            this.startTime = obj.StartTime.substring(0, 5);
            this.endTime = obj.EndTime.substring(0, 5);
            if (obj.Format) {
                this.format = new Array<string>();
                obj.Format.forEach((format: string) => {
                    this.format.push(format);
                });
            }
        }
    }
}
